<template>
  <v-main>
    <!--Laptop view-->
    <v-container class="hidden-sm-and-down">
      <div class="centered">
        <v-card
          width="64%"
          flat
          class="pa-8"
          style="padding-bottom:600px;border:3px solid #f5f5f5; border-radius: 30px 30px 0px 0px"
           v-if="!loading"
        >
          <!--Buttons -->
          <h2
            style="margin-top: 10px"
            v-if="userData.buttons != '' && !loading"
          ></h2>
          <div v-for="button in buttonList" :key="button.name">
            <div class="mb-3">
              <v-btn
                target="_blank"
                class="flex justify-between"
                style="border-radius: 12px"
                x-large
                block
                :color="userData.btncolor"
                :style="{ color: userData.bg }"
                :href="button.button"
              >
               <div class="flex justify-between">
                 <span> {{ button.name }}</span>
                <v-icon size="17px" class="linkIcon">mdi-arrow-top-right</v-icon>
                </div>
              </v-btn>
              <div v-if="showEdit" style="float:right;margin-top:-10px">
                <!-- <v-btn x-small fab class="mr-3" @click="editButton(button)"
                  ><v-icon>mdi-pen</v-icon></v-btn
                > -->
                <v-btn x-small fab class="mr-3" @click="sureButton(button)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </div>
          </div>

          <!--Videos-->
          <h2 style="margin-top: 24px" v-if="userData.videos != '' && !loading">
            Videos
          </h2>
          <div v-for="(video, i) in videoList" :key="i">
            <v-card
              width="560px"
              style="border-radius: 20px; margin-bottom: 20px"
              height="315px"
              elevation="24"
            >
              <iframe
                width="560"
                height="315"
                :src="video"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                style="position: relative; border-radius: 20px"
              >
              </iframe>
              <div
                v-if="showEdit"
                style="float:right;position:absolute;bottom:0;right:0"
              >
                <v-btn small fab class="mr-3" @click="editVideo(video)"
                  ><v-icon>mdi-pen</v-icon></v-btn
                >
                <v-btn small fab class="mr-3" @click="sureVideo(video)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </v-card>
          </div>

          <!--Articles-->
          <h2
            style="margin-top: 50px"
            v-if="userData.articles != '' && !loading"
          >
            Articles
          </h2>
          <div v-for="article in articleList" :key="article.title">
            <v-card
              style="border-radius: 10px"
              class="pa-5 mb-8 d-flex"
              height="155px"
              :href="article.website"
              target="_blank"
            >
                  <v-img
                    style="border-radius: 10px"
                    :src="article.banner"
                    width="300px"
                  >
                  </v-img>
               
                  <h2>{{ article.title }}</h2>
                  <v-btn
                    fab
                    width="20px"
                    height="20px"
                    :color="article.themeColor"
                    style="
                      margin: 0px 12px 12px 0px;
                      font-size: 5px;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                      color: white;
                    "
                    ><v-icon x-small>mdi-arrow-right</v-icon></v-btn
                  >
                  <p style="font-size: 10px">{{ article.description }}</p>
               
            </v-card>
            <div v-if="showEdit" style="margin-top:-12px;margin-bottom:15px">
              <!-- <v-btn x-small fab class="mr-3" @click="editArticle(article)"
                ><v-icon>mdi-pen</v-icon></v-btn
              > -->
              <v-btn x-small fab class="mr-3" @click="sureArticle(article)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </div>
          </div>

          <!--Images-->
          <marquee>
            <div class="d-flex">
          <div
            v-for="(image,i) in userData.images"
            :key="i"
            style="margin-top: 20px"
          >
            <v-card
              style="float: left; border-radius: 20px; margin-bottom: 20px"
              elevation="24"
              class="mr-4"
              width="300px"
              height="300px"
            >
              <img class="zoom" width="100%" height="100%" :src="image"
              
              style="border-radius:20px"
               />
              <div
                v-if="showEdit"
                style="float:right;position:absolute;bottom:0;right:0"
              >
                <!-- <v-btn small fab class="mr-3" @click="editImage(image)"
                  ><v-icon>mdi-pen</v-icon></v-btn
                > -->
                <v-btn small fab class="mr-3" @click="sureImage(image)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </v-card>
          </div>
          </div>
           </marquee>
         

          <!--Links-->
        </v-card>
      </div>
    </v-container>

    <!--Mobile view -->
    <v-main class="hidden-md-and-up">
      <div style="margin-top: 10px">
        <div>
          <v-card
            flat
            class="pa-8"
            style="padding-bottom:600px;border:solid 3px #f5f5f5; border-radius: 30px 30px 0px 0px"
            v-if="!loading"
          >
            <h2
              style="margin-top: 10px"
              v-if="userData.buttons != '' && !loading"
            ></h2>
            <div v-for="button in buttonList" :key="button.name">
              <div class="mb-4">
                <v-btn
                  target="_blank"
                  style="border-radius: 12px"
                  x-large
                  block
                  :color="userData.btncolor"
                  :style="{ color: userData.bg }"
                  :href="button.button"
                >
                  <div class="flex justify-between">
                 <span v-if="button.name.length < 22"> {{ button.name }}</span>
                 <span v-if="button.name.length >= 22"> {{ button.name.slice(0,22)}}...</span>
                <v-icon size="17px" class="linkIcon">mdi-arrow-top-right</v-icon>
                </div>
                </v-btn>
                <div v-if="showEdit" style="float:right;margin-top:-10px">
                  <!-- <v-btn x-small fab class="mr-3" @click="editButton(button)"
                  ><v-icon>mdi-pen</v-icon></v-btn
                > -->
                  <v-btn x-small fab class="mr-3" @click="sureButton(button)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </div>
              </div>
            </div>
            <!--Videos-->
            <h2 style="margin-top: 23px" v-if="userData.videos != '' && !loading">
            Videos
          </h2>
            <div
              class="text-center"
              v-for="(video, i) in videoList"
              :key="i"
            >
              <v-card
                width="100%"
                height="250px"
                style="border-radius: 20px; margin-bottom: 30px"
              >
                <iframe
                  width="100%"
                  :src="video"
                  height="250px"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="margin-bottom: -20px;border-radius:20px"
                >
                </iframe>
                <div v-if="showEdit" style="float:right">
                  <v-btn x-small fab class="mr-3" @click="editVideo(video)"
                    ><v-icon>mdi-pen</v-icon></v-btn
                  >
                  <v-btn x-small fab class="mr-3" @click="sureVideo(video)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </div>
              </v-card>
            </div>

            <!--Articles-->
            <h2
              style="margin-top: 50px"
              v-if="userData.articles != '' && !loading"
            >
              Articles
            </h2>
            <div v-for="article in articleList" :key="article.title">
              <v-card
                style="border-radius: 10px"
                class="pa-3 mb-5"
                width="100%"
                height="135px"
                target="_blank"
                :href="article.website"
              >
                <div class="d-flex">
                    <v-img
                      style="border-radius: 10px"
                      width="120px"
                      height="80px"
                      :src="article.banner"
                    >
                    </v-img>
                   
                
                    <h2 class="ml-2 mt-2" style="font-size: 15px">{{ article.title }}</h2>
                    <v-btn
                      fab
                      width="20px"
                      height="20px"
                      :color="article.themeColor"
                      style="
                        margin: 0px 12px 12px 0px;
                        font-size: 5px;
                        right: 0;
                        position: absolute;
                        bottom: 0;
                        color: white;
                      "
                      ><v-icon x-small>mdi-arrow-right</v-icon></v-btn
                    >
                    <p style="font-size: 6px">{{ article.description }}</p>
                  
                </div>
              </v-card>
              <div v-if="showEdit" style="margin-top:-12px;margin-bottom:15px">
                <!-- <v-btn x-small fab class="mr-3" @click="editArticle(article)"
                ><v-icon>mdi-pen</v-icon></v-btn
              > -->
                <v-btn x-small fab class="mr-3" @click="sureArticle(article)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </div>

            <!--Images-->
            <marquee>
            <div class="d-flex">
            <div
              v-for="(image, i) in userData.images"
              :key="i"
              style="margin-top: 20px"
            
            >
              <v-card
                style="float: left; border-radius: 20px; margin-bottom: 10px"
                height="200px"
                width="200px"
                elevation="24"
                class="mr-4"
                v-if="!loading"
              >
                <img height="200px"
                class="zoom"
                width="200px" style="border-radius:20px" :src="image" />
                <div
                  v-if="showEdit"
                  style="float:right;position:absolute;bottom:0;right:0"
                >
                  <!-- <v-btn small fab class="mr-3" @click="editImage(image)"
                  ><v-icon>mdi-pen</v-icon></v-btn
                > -->
                  <v-btn x-small fab class="mr-3" @click="sureImage(image)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </div>
              </v-card>
            </div>
            </div>
            </marquee>
          </v-card>
        </div>
      </div>
    </v-main>
     <v-btn
      v-if="showEdit"
      @click="sheet = !sheet"
      class="navbar addButton"
      :style="{ color: userData.bg }"
      :color="userData.btncolor"
      fab
    >
      <v-icon :color="userData.bg">mdi-plus</v-icon>
    </v-btn>

    <v-btn
      to="/signup"
      class="madeWithTippings addButton"
      :style="{ color: userData.bg }"
      :color="userData.btncolor"
      elevation="14"
      style="font-size:10px"
    >
     Made with Tippings
    </v-btn>
    <div
      class="darkmode addButton"
      rounded
      flat
      style="width:120px"
      
    >
    <ColorModePicker />
    </div>
    <v-bottom-sheet style="border-radius: 20px" v-model="sheet">
      <Blocks :userData="userData" />
    </v-bottom-sheet>

    <v-dialog v-model="dialogVideo" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
        <v-btn class="mr-5" @click="dialogVideo = false">No</v-btn>
        <v-btn :loading="btnloading" @click="deleteVideo()">Yes</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogButton" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
        <v-btn class="mr-5" @click="dialogButton = false">No</v-btn>
        <v-btn :loading="btnloading" @click="deleteButton()">Yes</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogImage" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
        <v-btn class="mr-5" @click="dialogimage = false">No</v-btn>
        <v-btn :loading="btnloading" @click="deleteImage()">Yes</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogArticle" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
        <v-btn class="mr-5" @click="dialogArticle = false">No</v-btn>
        <v-btn :loading="btnloading" @click="deleteArticle()">Yes</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="doneDialog" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
        <v-btn :loading="btnloading" @click="done()">Ok</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" width="500px">
      <v-card
        width="500px"
        :color="userData.btncolor"
        :style="{ color: userData.bg }"
        class="pa-5 text-center"
      >
        <p class="font-weight-bold" style="font-size:20px;text-align:start">
          Update video
        </p>
        <v-text-field
          outlined
          style="border-radius:12px;height:67px"
          label="Video link"
          :color="userData.bg"
          v-model="editedVideo"
        />

        <v-btn
          block
          style="border-radius:12px"
          :color="userData.bg"
          :style="{ color: userData.btncolor }"
          large
          :loading="btnloading"
          @click="updateVideo(computedVideo)"
          >Update</v-btn
        >

        <iframe
          width="100%"
          :src="computedVideo"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          style="margin-top: 20px"
        >
        </iframe>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import Blocks from "@/components/Blocks";
import ColorModePicker from "@/components/ColorModePicker"
import { doc, updateDoc, arrayRemove, arrayUnion } from "firebase/firestore";
import db from "@/db";
export default {
  data: () => ({
    videoOverlay: true,
    showEdit: false,
    sheet: false,
    videoTBD: {},
    buttonTBD: "",
    imageTBD: "",
    articleTBD: "",
    btnloading: false,
    doneDialog: false,
    dialogVideo: false,
    dialogButton: false,
    dialogImage: false,
    dialogArticle: false,
    editDialog: false,
    editedVideo: "",
    editingVideo: "",
    message:"",
    title:""
  }),

  props: {
    userData: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    Blocks,
    ColorModePicker
  },
  computed: {
    computedVideo() {
      return "https://www.youtube.com/embed/" + this.editedVideo.split("=")[1];
    },
    buttonList(){
      return this.userData.buttons.slice().reverse()
    },
    videoList(){
      return this.userData.videos.slice().reverse()
    },
     articleList(){
      return this.userData.articles.slice().reverse()
    },
    //  imageList(){
    //   return this.userData.images.slice().reverse()
    // },
    

  },

  created() {
    if (this.$route.params.id == localStorage.getItem("tippingsKey")) {
      this.showEdit = true;
    }
  },
  methods: {

    editVideo(e) {
      this.editedVideo = e;
      this.editingVideo = e;
      this.editDialog = !this.editDialog;
    },

    async updateVideo() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        videos: arrayRemove(this.editingVideo)
      });
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        videos: arrayUnion(this.computedVideo)
      });
      this.btnloading = false;
      this.doneDialog = true;
      this.title = "Video updated successfully!";
      this.message = "The Video has been updated on your Tippings page";
    },
    sureVideo(e) {
      this.videoTBD = e;
      this.dialogVideo = true;
      this.message = "Are you sure you want to delete this video?";
      this.title = "Are you sure?";
    },
    sureImage(e) {
      this.imageTBD = e;
      this.dialogImage = true;
      this.message = "Are you sure you want to delete this image?";
      this.title = "Are you sure?";
    },

    sureButton(e) {
      this.buttonTBD = e;
      this.dialogButton = true;
      this.message = "Are you sure you want to delete this button?";
      this.title = "Are you sure?";
    },

    sureArticle(e) {
      this.articleTBD = e;
      this.dialogArticle = true;
      this.message = "Are you sure you want to delete this article?";
      this.title = "Are you sure?";
    },

    async deleteVideo() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        videos: arrayRemove(this.videoTBD)
      });
      this.btnloading = false;
      this.doneDialog = true;
      this.title = "Video deleted successfully!";
      this.message = "The Video has been deleted from your Tippings page";
    },

    async deleteImage() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        images: arrayRemove(this.imageTBD)
      });
      this.btnloading = false;
      this.doneDialog = true;
      this.title = "Image deleted successfully!";
      this.message = "The image has been deleted from your Tippings page";
    },

    async deleteArticle() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        articles: arrayRemove(this.articleTBD)
      });
      this.btnloading = false;
      this.doneDialog = true;
      this.title = "Article deleted successfully!";
      this.message = "The article has been deleted from your Tippings page";
    },

    async deleteButton() {
      this.btnloading = true;
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        buttons: arrayRemove(this.buttonTBD)
      });
      this.btnloading = false;
      this.doneDialog = true;
      this.title = "Button deleted successfully!";
      this.message = "The button has been deleted from your Tippings page";
    },

    done() {
      location.reload();
    }
  }
};
</script>

<style>
.pulsingButton {
  box-shadow: 0 0 0 0 rgba(68, 67, 67, 0.7);
  background-color: black;
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}

/* Comment-out to have the button continue to pulse on mouseover */

a.pulsingButton:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
  color: #ffffff;
}

/* Animation */

@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

.navbar {
  overflow: hidden;
  position: fixed;
  text-align: center;
  bottom: 0;
  right: 0;
  margin: 0px 7px 19px 0px;
  width: 100%;
}

.madeWithTippings{
   position: fixed;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, -50%);
  margin: 0 auto;

}

.madeWithTippings:hover{
  background: red !important;

}

.darkmode {
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0px 7px 19px 10px;
  width: 100%;
}

.elementBorder {
  border: solid 1px grey;
  margin-bottom: 10px;
  padding: 10px;
  width: 100%;
  font-size: 19px;
}

.linkIcon{
   float:right;
   display: block;
   margin-top:6px;
   margin-left: 10px;
   width: 10px; 
   height: 10px;
   /* &:before { content: attr(data-icon); } */
}

.zoom {
  transition: transform .2s; /* Animation */
  background:linear-gradient(0deg, rgba(15, 15, 15, 0.911), rgba(59, 59, 59, 0.3))

}

.zoom:hover {
  transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

</style>
